module.exports = __webpack_public_path__ + "img/av17a.f2006994.png";